// GENERATE BY ../scripts/generate.js
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
import React, { forwardRef, MutableRefObject } from 'react';
import { IconProps } from '../type';
import classNames from 'classnames';
import useConfig from '../../_util/useConfig';
import useSizeProps from '../useSizeProps';

const CheckCircleFilledIcon = (props: IconProps, ref: MutableRefObject<SVGSVGElement>) => {
  const { classPrefix } = useConfig();
  const { size, className: customClassName, style: customStyle, ...restProps } = props;
  const { className: sizeClassName, style: sizeStyle } = useSizeProps(size);
  const className = classNames(classPrefix + '-icon',classPrefix+'-icon-check-circle-filled', sizeClassName, customClassName);
  const style = { ...customStyle, ...sizeStyle }

  return (
    <svg ref={ref} className={className} style={style} {...restProps} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path fillOpacity=".9" fillRule="evenodd" d="M512 96C741.7504576 96 928 282.24954432 928 512 928 741.7504576 741.7504576 928 512 928 282.24954432 928 96 741.7504576 96 512 96 282.24954432 282.24954432 96 512 96ZM690.8655168 353.58818368L464.56401024 579.82818368 328.82684416 444.09785152 283.57201024 489.35268544 464.59134592 670.3720192 509.84617984 625.1171872 736.120352 398.8430176 690.8655168 353.58818368Z"/></svg>
  )
};

CheckCircleFilledIcon.displayName = 'CheckCircleFilledIcon';

export default forwardRef<SVGSVGElement, IconProps>(CheckCircleFilledIcon);
